import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn.js';
/**
 * Plain text input. Pair with <Field label="…"> for the label + error
 * wrapping. Forward-refs so react-hook-form can register it.
 */
export const Input = forwardRef(function Input({ invalid, className, 'aria-invalid': ariaInvalid, ...rest }, ref) {
    // The danger border must also fire when the error state is injected via
    // <Field error="…">, which sets `aria-invalid` on the cloned child but
    // never the `invalid` prop (that prop doesn't exist on the native
    // select/textarea children Field also wraps). Treat either signal as
    // invalid so validated forms show both the message and the red border.
    const isInvalid = invalid === true || ariaInvalid === true || ariaInvalid === 'true';
    return (_jsx("input", { ref: ref, "aria-invalid": isInvalid || undefined, className: cn('block w-full font-body text-base text-ink', 'rounded-md border bg-paper px-3 py-2', 'placeholder:text-ink-muted', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream', 'disabled:bg-cream/50 disabled:text-ink-muted disabled:cursor-not-allowed', isInvalid
            ? 'border-danger focus-visible:ring-danger/40'
            : 'border-border focus-visible:ring-forest/40 focus:border-forest', className), ...rest }));
});
//# sourceMappingURL=Input.js.map